export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


export const USER_LOGIN_URL = `${API_BASE_URL}/user/login`;
export const SERVER_RESTART_URL = `${API_BASE_URL}/server/restart`;
export const DATA_BACKUP_URL = `${API_BASE_URL}/user/backup`;


// Retail Bill URL
export const NEW_BILL_GENERATE_URL = `${API_BASE_URL}/user/billRequest`;
export const BILL_FETCH_URL = `${API_BASE_URL}/user/getBill`;
// Re-save a FRESH retail bill within 20 minutes of creation (returns the reprint)
export const UPDATE_BILL_URL = `${API_BASE_URL}/user/update/billRequest`;

export const EXCHANGE_BILL_URL = `${API_BASE_URL}/user/exchange/billRequest`;
export const ITEM_RETURN_URL = `${API_BASE_URL}/user/return_stock/bill`;
export const DEFECT_ITEM_RETURN= `${API_BASE_URL}/user/stock/defect`;
export const DELETE_BILL_URL= `${API_BASE_URL}/user/cancelBill`;


// Invoice
export const CUSTOMER_DETAILED_INVOICE = `${API_BASE_URL}/invoice/getBill`;
export const INVOICE_LIST_BY_DATE = `${API_BASE_URL}/invoice/getBillByDate`;
export const INVOICE_LIST_BY_DATE_AND_TIME = `${API_BASE_URL}/invoice/getBillByDateAndTime`;
export const INVOICE_LIST_BY_BILL_NO = `${API_BASE_URL}/invoice/bill/getBill`;


export const INTERCOMPANY_DETAILED_INVOICE = `${API_BASE_URL}/invoice/intercompany/getBill`;
export const INTERCOMPANY_INVOICE_LIST_BY_DATE = `${API_BASE_URL}/invoice/intercompany/getBillByDate`;
export const INTERCOMPANY_INVOICE_LIST_BY_DATE_AND_TIME = `${API_BASE_URL}/invoice/intercompany/getBillByDateAndTime`;
export const BILL_UPDATE_HISTORY = `${API_BASE_URL}/invoice/billModificationHistory`;
export const ITEM_CLOTH_BY_STORE_URL = `${API_BASE_URL}/inventory/cloth/getByStoreId`;
export const FIND_ITEM_UPDATE_HISTORT_URL= `${API_BASE_URL}/inventory/view/updateHistory`;


export const FIND_GROUPS_INVENTORY= `${API_BASE_URL}/groupManager/findGroupList`;
export const FIND_GROUPS_ITEM_INVENTORY= `${API_BASE_URL}/groupManager/findItemByGeneralGroupId`;
export const ITEM_UNGROUP_URL= `${API_BASE_URL}/groupManager/item/ungroup`;


export const UPDATE_CLOTH_ITEM_URL= `${API_BASE_URL}/inventory/cloth/update`;
export const FIND_CLOTH_BY_ID_URL= `${API_BASE_URL}/inventory/cloth/find`;



// Store URL
export const FETCH_STORES_URL = `${API_BASE_URL}/store/getAllStores`;
export const FETCH_STORE_USER_URL= `${API_BASE_URL}/user/getUserByStore`;

// Transaction Daily Cash
export const CREATE_TRANSACTION_URL = `${API_BASE_URL}/user/daily/create`;
export const FETCH_CASH_BALANCE_URL = `${API_BASE_URL}/user/daily/balance`;


// Custom Cloth 
export const CUSTOM_CLOTH_PANA_SIZE = `${API_BASE_URL}/user/item/cloth/distinctPanaSize`;
export const FIND_CLOTH = `${API_BASE_URL}/user/item/cloth/findCloth`;

export const FIND_TRANSACTION_BILL_NO = `${API_BASE_URL}/user/transaction/findTransactionByBillNo`;
export const UPDATE_TRANSACTION_BILL_NO = `${API_BASE_URL}/user/transaction/updateBillTransaction`;

export const FETCH_TRANSACTION_BY_DATE_URL = `${API_BASE_URL}/user/transaction/viewTransactionList`;


export const GET_SCHOOL_URL = `${API_BASE_URL}/user/filter/getSchool`;
export const GET_SCHOOL_ITEM_TYPE_URL = `${API_BASE_URL}/user/filter/school/item_type`;
export const GET_ITEM_TYPE_URL = `${API_BASE_URL}/user/filter/item_type`;
export const GET_ITEM_CATEGORY_BY_TYPE_URL = `${API_BASE_URL}/user/filter/item_category/item_type`;
export const GET_ITEM_LIST_BY_TYPE_URL = `${API_BASE_URL}/user/filter/item_list_type`;
export const GET_ITEM_LIST_BY_SCHOOL_URL = `${API_BASE_URL}/user/filter/item_list_school_code`;
export const GET_ALL_ITEMS_URL = `${API_BASE_URL}/user/filter/getAllItems`;


export const BULK_UPDATE_URL = `${API_BASE_URL}/inventory/bulk/update`;
export const HIDE_ITEMS_URL = `${API_BASE_URL}/inventory/update/item_status/hide`;
export const SHOW_ITEMS_URL = `${API_BASE_URL}/inventory/update/item_status/show`;
